module.exports = __webpack_public_path__ + "static/img/label-03.029b381.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/flash/label-03.png
// module id = xjTK
// module chunks = 150